import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserAppletContainerModel } from "../../../../../models/aggregates/applet-store/user-applet-container.model";
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';


// http://api.akaun.cloud/core2/tnt/dm/applet-login-subject-link/applet-login-ep

@Injectable({
  providedIn: 'root'
})
export class UserAppletTenantLoginEPService extends BaseApiTemplateService<UserAppletContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/applet-login-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/applet-login-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/applet-login-ep';
    this.httpClient = http;
  }

  public getByGuidCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    guid: any,
  ): Observable<PagingResponseModel<UserAppletContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl +'/'+ guid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<UserAppletContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidCriteriaCustom(
    pagination: Pagination,
    visa: ApiVisa,
    guid: any,
  ): Observable<PagingResponseModel<UserAppletContainerModel>> {
    const urlPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/custom/applet-login-ep' 
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + urlPath;
    }
    const UrlByCriteria =
      this.apiUrl +'/'+ guid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<UserAppletContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  // /return-role/applet-login-ep/{applet_guid}/query

  public getByByCriteriaReturnRoles(
    pagination: Pagination,
    visa: ApiVisa,
    guid: any,
  ): Observable<PagingResponseModel<any>> {
    const urlPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/return-role/applet-login-ep'
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + urlPath;
    }
    const UrlByCriteria =
      this.apiUrl + '/' + guid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  
}
